'use client'

import { sendEmail } from "@/app/actions/sendEmail"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { UnderlineInput } from "@/components/ui/underline-input"
import { UnderlineTextarea } from "@/components/ui/underline-textarea"
import { Phone, Mail, MapPin } from 'lucide-react'
import { useActionState } from "react"


function Page({
    dict,
 }: {
    dict: any
 }) {
    const initialState = { success: false, error: null }
    const [state, formAction, pending] = useActionState(sendEmail, initialState)

    const contactPageTranslations = dict?.contactPage

    return (
        <div className="py-20 flex flex-col items-center mt-8">
            <aside className="text-center">
                <h1 className="text-3xl font-semibold">{contactPageTranslations?.title}</h1>
                <p className="text-sm mt-3 text-[#717171]">{contactPageTranslations?.subtitle}</p>
            </aside>

            <div className="grid md:grid-cols-2 grid-cols-1 gap-4 rounded-2xl shadow-md border border-gray-200 mt-8 p-2 min-h-[600px]">
                <div className="bg-[#006633] text-white px-8 py-12 rounded-2xl relative">
                    <div className="absolute right-0 bottom-0 hidden md:block">
                        <svg width="208" height="209" viewBox="0 0 208 209" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="162.5" cy="160.5" r="134.5" fill="white" fill-opacity="0.12"/>
                            <circle cx="69" cy="69" r="69" fill="#FFF9F9" fill-opacity="0.13"/>
                        </svg>
                    </div>
                    <p className="text-2xl font-semibold">{contactPageTranslations?.contactInfo}</p>
                    <ul className="text-sm flex flex-col gap-12 mt-32">
                        <li className="flex gap-2">
                            <Phone className="mr-2" size={20} />
                            <span dir="ltr">+213 558 31 03 17</span>
                        </li>
                        <li className="flex gap-2">
                            <Mail className="mr-2" size={20} />
                            <span>info@soukna.net</span>  
                        </li>
                        <li className="flex gap-2">
                            <MapPin className="mr-2" size={20} />
                            <span>{contactPageTranslations?.address}</span>
                        </li>
                    </ul>
                </div>
                {/* FORM */}
                <form action={formAction} className="py-16 px-4 md:grid md:grid-cols-2 grid-cols-1 gap-6">
                    <div className="flex flex-col gap-2 mb-3">
                        <Label htmlFor="lastName">{contactPageTranslations?.form?.lastName}</Label>
                        <UnderlineInput
                            id="lastName"
                            name="lastName"
                            type="text"
                            required
                        />
                    </div>
                    <div className="flex flex-col gap-2 mb-3">
                        <Label htmlFor="firstName">{contactPageTranslations?.form?.firstName}</Label>
                        <UnderlineInput
                            id="firstName"
                            name="firstName"
                            type="text"
                            required
                        />
                    </div>
                    <div className="flex flex-col gap-2 mb-3">
                        <Label htmlFor="email">{contactPageTranslations?.form?.email}</Label>
                        <UnderlineInput
                            id="email"
                            name="email"
                            type="email"
                            required
                        />
                    </div>
                    <div className="flex flex-col gap-2 mb-3">
                        <Label htmlFor="phone">{contactPageTranslations?.form?.phone}</Label>
                        <UnderlineInput
                            id="phone"
                            name="phone"
                            type="text"
                            required
                        />
                    </div>
                    <div className="col-span-2 flex flex-col gap-2 mb-3">
                        <Label htmlFor="message">{contactPageTranslations?.form?.message}</Label>
                        <UnderlineTextarea
                            id="message"
                            name="message"
                            placeholder={contactPageTranslations?.form?.messagePlaceholder}
                            rows={6}
                            required
                        />
                    </div>

                    <div className="col-span-2 flex justify-end">
                        <Button 
                            type="submit" 
                            className="text-white"
                            disabled={pending}
                            >
                            {pending ? contactPageTranslations?.form?.buttonLoadingLabel : contactPageTranslations?.form?.buttonLabel}
                        </Button>
                    </div>

                    {state?.success && (
                        <p className="col-span-2 text-green-600 mt-4">{contactPageTranslations?.form?.successMessage}</p>
                    )}
                    {state?.error && (
                        <p className="col-span-2 text-red-600 mt-4">{contactPageTranslations?.form?.errorMessage}</p>
                    )}
                </form>
            </div>
        </div>
    )
}

export default Page